<mat-form-field appearance="outline">

  <mat-label>UF</mat-label>

  <mat-select required [value]="value" (selectionChange)="setValue($event.value)">

    <mat-option *ngFor="let uf of ufs" [value]="uf">
      {{ uf }}
    </mat-option>

  </mat-select>

</mat-form-field>
